var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundFlagEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pl2qeucmpa)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ytsorqymhb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ytsorqymhb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.62 23.98h34.76c.342 0 .62-.282.62-.63V.65a.626.626 0 0 0-.62-.63H.62A.626.626 0 0 0 0 .65v22.7c0 .348.278.63.62.63z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD250",
    d: "M0 4.8h24v14.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.552 12.275.526-2.406a.353.353 0 0 0-.341-.431h-.37c-.224 0-.39.21-.342.431l.527 2.406z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M15.931 11.014h1.241v5.359h-1.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M15.62 10.384h1.862v.631H15.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M14.379 12.275h3.104v.631h-3.104zM17.482 14.797l-1.862-.63v-.63l1.862.63v.63zM7.241 12.275l.526-2.406a.353.353 0 0 0-.34-.431h-.371c-.224 0-.39.21-.341.431l.526 2.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.414 10.383a.626.626 0 0 0-.621.63v4.1c0 .766.704 2.206 3.103 2.206 2.4 0 3.104-1.44 3.104-2.207v-4.098a.626.626 0 0 0-.621-.63H9.414z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.896 13.536H8.793v-2.522c0-.348.278-.63.62-.63h2.483v3.152zM11.896 13.536H15v1.576c0 .871-.695 1.577-1.552 1.577a1.564 1.564 0 0 1-1.552-1.577v-1.576z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.793 13.536h3.103v1.576c0 .871-.694 1.577-1.551 1.577a1.564 1.564 0 0 1-1.552-1.577v-1.576z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.276 16.366v-2.83h-.621v3.121c.23-.048.44-.151.62-.29zM10.034 16.657v-3.12h-.62v2.83c.18.139.39.242.62.29z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M9.414 12.275h1.862v.631H9.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M9.414 11.014h1.862v.631H9.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M9.724 11.389h1.241v1.142H9.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M6.62 11.014h1.241v5.359H6.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M6.31 16.059h1.862v.631H6.31zM6.31 10.384h1.862v.631H6.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M6 16.689h2.483v.631H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M15.931 16.059h1.862v.631h-1.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M15.31 16.689h2.483v.631H15.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M10.034 9.753h3.724v.631h-3.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M11.586 7.861h.621v1.892h-.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.345 7.861a.94.94 0 0 0 .93.946.94.94 0 0 0 .932-.946.94.94 0 0 0-.931-.946.94.94 0 0 0-.931.946zm.62 0c0-.174.14-.315.31-.315.172 0 .311.141.311.315 0 .174-.14.316-.31.316a.313.313 0 0 1-.31-.316z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.586 7.861a.94.94 0 0 0 .931.946.94.94 0 0 0 .931-.946.94.94 0 0 0-.93-.946.94.94 0 0 0-.932.946zm.62 0c0-.174.14-.315.311-.315.171 0 .31.141.31.315 0 .174-.139.316-.31.316a.313.313 0 0 1-.31-.316z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.827 8.492a.94.94 0 0 0 .931.946.94.94 0 0 0 .931-.946.94.94 0 0 0-.93-.946.94.94 0 0 0-.932.946zm.621 0c0-.174.14-.315.31-.315.172 0 .31.14.31.315 0 .174-.138.315-.31.315a.313.313 0 0 1-.31-.315zM9.103 8.492a.94.94 0 0 0 .931.946.94.94 0 0 0 .931-.946.94.94 0 0 0-.93-.946.94.94 0 0 0-.932.946zm.62 0c0-.174.14-.315.311-.315.172 0 .31.14.31.315a.313.313 0 0 1-.31.315.313.313 0 0 1-.31-.315z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.517 14.167h1.862v.945a.94.94 0 0 1-.931.946.94.94 0 0 1-.931-.946v-.945zm1.241.945v-.315h-.62v.315c0 .174.139.316.31.316.171 0 .31-.142.31-.316z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.448 12.906a.626.626 0 0 1-.62-.631v-.63c0-.349.277-.631.62-.631.343 0 .62.282.62.63v.631c0 .348-.277.63-.62.63z",
    fill: "#FFA0D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.896,
    cy: 13.536,
    rx: 0.931,
    ry: 0.946,
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M11.586 6.6h.621v1.892h-.621z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.034 9.753-.62-.63.363-.37a2.974 2.974 0 0 1 2.12-.892c.794 0 1.556.321 2.119.892l.363.37-.62.63h-3.725z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.896,
    cy: 9.358,
    rx: 0.31,
    ry: 0.53,
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.655,
    cy: 9.358,
    rx: 0.31,
    ry: 0.53,
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.137,
    cy: 9.358,
    rx: 0.31,
    ry: 0.53,
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M6.31 12.275h3.104v.631H6.31zM6.31 14.797l1.862-.63v-.63l-1.862.63v.63z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pl2qeucmpa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagEs);
export default __webpack_public_path__ + "static/media/round-flag-es.254c8be8ced5db3a7a71d9350cfb7564.svg";
export { ForwardRef as ReactComponent };